<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-ums__member}">
      <el-table v-loading="dataListLoading" :data="dataList" border style="width: 100%;">
        <el-table-column label="优果类型" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.balanceType===2">普通优果</el-tag>
            <el-tag v-else-if="scope.row.balanceType===6">红果</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="sumBalance" label="总优果" header-align="center" align="center"></el-table-column>
        <el-table-column prop="platBalance" label="平台优果" header-align="center" align="center"></el-table-column>
        <el-table-column prop="balance" label="用户优果" header-align="center" align="center"></el-table-column>
        <el-table-column prop="updateDate" label="时间" header-align="center" align="center"></el-table-column>
        <el-table-column label="状态" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag type="danger" v-if="!scope.row.shareMoneyStatus">待分红</el-tag>
            <el-tag v-else-if="scope.row.shareMoneyStatus">完成</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="shareMoneyCount" label="分红次数" header-align="center" align="center"></el-table-column>

        <el-table-column label="操作" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="!scope.row.shareMoneyStatus" type="text" size="small" @click="cancelShareMoneyHandle">取消分红</el-button>
            <el-button v-else="scope.row.shareMoneyStatus" type="text" size="small" @click="shareMoneyHandle">发放分红</el-button>
          </template>
        </el-table-column>
      </el-table>

      <balancepool-sharemoney ref="shareMoneyRef" @refreshDataList="getDataList"></balancepool-sharemoney>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import BalancepoolSharemoney from './balancepool-sharemoney'

export default {
  mixins: [mixinViewModule],
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/cp/balancepool/list',
      },
    }
  },
  created() {
    const that = this;
  },
  methods: {
    shareMoneyHandle(){
      const that=this;
      that.$nextTick(()=>{
        this.$refs.shareMoneyRef.init();
      });
    },
    cancelShareMoneyHandle(){
      const that=this;
      that.$confirm('是否确定取消发放分红?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.$http['put']('/cp/balancepool/cancelsharemoney').then(({ data: res }) => {
          if (res.code !== 0) {
            return that.$message.error(res.msg)
          }
          that.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              that.getDataList();
            }
          })
        }).catch(() => {})
      });
    }
  }
  ,
  components: {
    BalancepoolSharemoney
  }
}
</script>
